
import { defineComponent} from 'vue'
import { mapState, useStore } from 'vuex'

export default defineComponent({
    setup (props, context) {
        const $store = useStore()

        const close = () => {
            $store.commit('SET_RULESHOW', false)
        }

        return {
            close
        }
    }
})
